import React from "react"
import { Link } from "react-router-dom"

import Config from "../../api/Config"
import { MNuArray } from "../../routes/menu"
import { classNames, getStandardRoute } from "../../utils/Helpers"

export const SideMenu = ({ ActiveMNu }) => {
    return (
        <React.Fragment>
            <aside className="lg:w-72 md:w-60 hidden md:flex flex-col bg-white dark:bg-slate-800/60 text-gray-200 fixed top-0 left-0 h-full z-20 border-r border-slate-200 dark:border-slate-600 ">
                <div className="flex-none flex items-center w-full py-2 px-4 justify-center sm:items-stretch sm:justify-start">
                    <div className="hidden sm:block">
                        <div className="flex space-x-4">
                            <Link to="/home" className={`text-theme mb-0 px-0 py-2 rounded-md flex flex-row align-middle items-baseline`} aria-current="page">
                                <span className="text-xl tracking-wide silkscreen-regular">
                                    {Config.APP_NAME}
                                </span>

                                <span className="text-slate-600 dark:text-white text-xs">
                                    ./CONSOLE
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>

                <div className="w-full pb-1 flex-1">
                    <ul className="flex flex-col pt-2 items-center h-full w-full overflow-auto text-slate-600 text-sm">
                        {
                            MNuArray.map((zMNu: any) => {
                                let DotMNu = zMNu.route.split('.')[0];
                                let RouteMNu = undefined

                                switch (DotMNu) {
                                    default:
                                        RouteMNu = getStandardRoute(zMNu.route)
                                        break;
                                }

                                return (
                                    <Link key={`zMNu-${zMNu.route}`} to={RouteMNu} className={classNames(
                                        ActiveMNu === zMNu.code ? 'text-orange-600 dark:text-orange-200 bg-orange-100 dark:bg-orange-900 border-l-4 border-orange-500 px-1' : 'hover:bg-slate-100 dark:hover:bg-slate-900 text-slate-600 dark:text-slate-300 px-2',
                                        "w-full py-3 flex items-center justify-center gap-x-2"
                                    )}>
                                        <div className="w-10 flex items-center justify-center">
                                            <span className={`fa-light ${zMNu.icon} fa-lg`}></span>
                                        </div>

                                        <div className="flex-1">
                                            {zMNu.name}
                                        </div>
                                    </Link>
                                )
                            })
                        }
                    </ul>
                </div>
            </aside >
        </React.Fragment>
    )
}